import { HttpHandler, HttpBackend, HttpInterceptor, HttpRequest, HttpEvent } from '@angular/common/http';
import { Observable, EMPTY } from 'rxjs';

export class ErmApiClientInterceptingHandler implements HttpHandler {
  private chain?: HttpHandler;

  constructor(
    private backend: HttpBackend,
    private interceptors: HttpInterceptor[]
  ) { }

  handle(request: HttpRequest<any>): Observable<HttpEvent<any>> {

    // Build up the http interceptor pipeline
    if (!this.chain) {
      const interceptors = this.interceptors || [];
      this.chain = interceptors.reduceRight(
        (next: HttpHandler, interceptor: HttpInterceptor) => new ErmApiClientHttpHandler(next, interceptor), this.backend);
    }
    if (this.chain) {
      return this.chain.handle(request);
    }
    return EMPTY;
  }
}

class ErmApiClientHttpHandler implements HttpHandler {

  constructor(private next: HttpHandler, private interceptor: HttpInterceptor) { }

  // Handle the http request by calling through to the interceptor
  handle(req: HttpRequest<any>): Observable<HttpEvent<any>> {
    return this.interceptor.intercept(req, this.next);
  }
}
